import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ConfirmationService, LazyLoadEvent, MessageService } from 'primeng/api';
import { Dropdown } from 'primeng/dropdown';
import { of } from 'rxjs';
import { catchError, finalize, map, tap } from "rxjs/operators";
import { AppGlobals } from 'src/app/app.globals';
import { AppBreadcrumbService } from 'src/app/core/breadcumb/app.breadcrumb.service';
import { CustomerService } from '../customers/service/customerservice';
import { ServiceInstance } from '../instances/domain/instance';
import { InstanceService } from '../instances/service/instanceservice';
import { Order } from './domain/order';
import { OrderService } from './service/orderservice';


@Component({
    templateUrl: './order.component.html',
    styleUrls: ['./order.component.scss']
})


export class OrderComponent {
    private token: string;
    public jobOrder_new: Order = {};
    public jobOrder_edit: Order = {};
    public jobOrderList: Order[];
    public clientsList: Document[] = [];
    public serviceInstanceList: ServiceInstance[];
    public serviceInstancesFilter: ServiceInstance[];
    public jobOrderCreateModal: boolean = false;
    public jobOrderEditModal: boolean = false;
    public jobOrderListLoading: boolean = true;
    public warningModal: boolean;
    public totalRecords: number;
    private projectId: string;
    event_lazy_local:LazyLoadEvent;
    itemsPerPage: number = 5;

    public orderItemsData = [
        {
            "id": "83hd873hd873",
            "creationTime": "2022-02-25T15:26:46.696Z",
            "updateTime": "2022-02-25T15:26:46.696Z",
            "deletionTime": "2022-02-25T15:26:46.696Z",
            "creatorUserId": "string",
            "updaterUserId": "string",
            "deleterUserId": "string",
            "isDeleted": true,
            "serviceInstanceId": "string",
            "orderId": "1",
            "description": "Order Item Description",
            "quantity": 1,
            "unit": 1,
            "unitCost": 2,
            "state": 0,
            "supplierId": "string",
            "note": "notes",
            "startTime": "2022-02-25T15:26:46.696Z",
            "endTime": "2022-02-25T15:26:46.696Z"
          }
    ];

    @ViewChild("dropdown_serviceIstances")
    dropdown_serviceIstances: Dropdown;

    constructor(
        private breadcrumbService: AppBreadcrumbService,
        private messageService: MessageService,
        private serviceInstaceService: InstanceService,
        private confirmationService: ConfirmationService,
        private OrderService: OrderService,
        private route: ActivatedRoute,
        private customerService: CustomerService) {
        let context = this;
        context.token = sessionStorage.getItem('alkenium_Token').toString();
        context.breadcrumbService.setItems([AppGlobals.setBreadCrumb('Order', '/orders', AppGlobals.userHasPermission("IS_CLIENT"))]);
        context.event_lazy_local = {} as LazyLoadEvent;
        context.setServiceIstanceFilter();
        context.setClientsDropdown();
        context.setServiceInstancesDropdown();
        this.projectId = this.route.snapshot.paramMap.get('id');
    }

    public createJobOrder() {
        let context = this;
        context.jobOrder_new = {} as Order;
        context.jobOrderCreateModal = true;
    }

    public addNewItemLine(){
        this.orderItemsData.push(
            {
                "id": "83hd873hd873",
                "creationTime": "2022-02-25T15:26:46.696Z",
                "updateTime": "2022-02-25T15:26:46.696Z",
                "deletionTime": "2022-02-25T15:26:46.696Z",
                "creatorUserId": "string",
                "updaterUserId": "string",
                "deleterUserId": "string",
                "isDeleted": true,
                "serviceInstanceId": "string",
                "orderId": "1",
                "description": "Order Item Description",
                "quantity": 1,
                "unit": 1,
                "unitCost": 2,
                "state": 0,
                "supplierId": "string",
                "note": "notes",
                "startTime": "2022-02-25T15:26:46.696Z",
                "endTime": "2022-02-25T15:26:46.696Z"
              });
    }

    setServiceIstanceFilter()
    {
        this.serviceInstaceService.getServiceInstanceList(this.token, null, null, null)
            .pipe(
                tap((res) => {
                    if(res.data != null)
                    {
                        this.serviceInstancesFilter = res.data.map((service) => {
                            return {
                            id: service.id,
                            name: service.name
                        }});
                    }
                }),
                catchError(() => {
                    return of();
                })
            )
            .subscribe();
    }

    private setClientsDropdown(){
        let context = this;
        context.customerService.getCustomerList(context.token, null, null) .pipe(
            tap((response) => {
                if(response.data != null){
                    context.clientsList = response.data.map((clients) => {
                        return {
                            id: clients.id,
                            name: clients.companyName
                        }
                });
            }
        }),catchError((error) => {return of();})).subscribe();
    }

    private setServiceInstancesDropdown()
    {
        this.serviceInstaceService.getServiceInstanceList(this.token, null, null, null)
            .pipe(
                tap((res) => {
                    if(res.data != null)
                    {
                        this.serviceInstanceList = res.data.map((service) => {
                            return {
                                id: service.id,
                                name: service.name
                            }
                        });
                    }
                }),
                catchError((res) => {
                    return of();
                })
            ).subscribe();
    }

    public editJobOrder(id:string){
        let context = this;
        context.OrderService.getJobOrder(context.token, id).pipe(
            tap((response) => {
                context.jobOrder_edit = {
                    id: response.data.id,
                    name: response.data.name,
                    alkeniumNumber: response.data.alkeniumNumber,
                    customerId: response.data.customerId,
                    description: response.data.description,
                    startDate: new Date(response.data.startTime),
                    endDate: new Date(response.data.endTime),
                } as Order;
                context.jobOrderEditModal = true;
            }),catchError((error) => {
                context.messageService.add({
                    severity:"error",
                    summary:"Error",
                    detail:error.message ?? error.error.title
                });
                context.jobOrderEditModal = false;
                return of();
        }),finalize(() => {})).subscribe();
    }

    closeCreateJobOrder() {
        this.jobOrderCreateModal = false;
    }

    closeEditJobOrder()
    {
        this.jobOrderEditModal = false;
    }

    public updateJobOrder(){
        let context = this;
        context.OrderService.updateJobOrder(context.token, context.jobOrder_edit).pipe(
            tap((res) => {
                    if(res.data != null){
                        context.messageService.add({
                            severity:'success',
                            summary:'Success',
                            detail:res.message ?? "Success"
                        });

                        context.jobOrderEditModal = false;
                    }
                }),
                catchError((res) => {
                    context.messageService.add({
                        severity:'error',
                        summary:'Error',
                        detail: res.error?.message ?? res.error.title
                    })

                    return of();
                }),
                finalize(()=>{
                    context.getList(null);
                    context.jobOrderEditModal = false;
        })).subscribe();
    }

    public saveJobOrder() {
        let context = this;
        context.jobOrder_new.projectId = context.projectId;
        context.OrderService.createJobOrder(context.token, context.jobOrder_new).pipe(
                tap((response) => {
                    if(response.data != null){
                        context.messageService.add({
                            severity:'success',
                            summary:'Success',
                            detail:response.message ?? "Success"
                        }); 
                    }
                }), catchError((res) => {
                    context.messageService.add({
                        severity:'error',
                        summary:'Error',
                        detail: res.error?.message ?? res.error.title
                    })
                    context.jobOrder_new = {} as Order;
                    return of();
                }),
                finalize(() => {
                    context.getList(null);
                    context.jobOrderCreateModal = false;
                })
            )
            .subscribe();
    }

    public deleteJobOrder(id: string, name:string) {
        let context = this;
        context.confirmationService.confirm({
            message: "You are about to delete '" + name + "'. Are you sure?",
            header: "Warning",
            icon: "pi pi-warning",
            acceptLabel: "Yes",
            rejectLabel: "No",
            accept: () => {
                context.OrderService.deleteJobOrder(context.token, id).pipe(
                        tap((res) => {
                            context.messageService.add({
                                severity: "success",
                                summary: "Success",
                                detail: res.message ?? "Success"
                            });
                        }),
                        catchError((res) => {
                            context.messageService.add({
                                severity: "error",
                                summary: "Error",
                                detail: res.error?.message ?? res.error.title
                            });
                            return of();
                        }),
                        finalize(() => {
                            context.getList(null);
                        })
                    )
                    .subscribe();
            },reject: () => {
                return;
            },
            rejectVisible: true
        });
    }

    public userHasPermission(permission: string){
        return (permission != '' && permission != null ? (!AppGlobals.userHasPermission(permission) ? false : true) : true);
    }
    
    public getList(event:LazyLoadEvent) {
        let context = this;
        if(event != null){
            context.event_lazy_local = event;
        }
            
        context.jobOrderListLoading = true;
        context.OrderService.getJobOrdersList(context.token, context.event_lazy_local, context.projectId)
            .pipe(
                tap((res) => {
                    if(res.data != null){
                        let slice = res.data.slice(context.event_lazy_local.first, (context.event_lazy_local.first + context.event_lazy_local.rows));
                        context.totalRecords = res.data.length;
                        context.jobOrderList = slice.map((jobOrder) => {
                            return {
                                id: jobOrder.id,
                                name: jobOrder.name,
                                description: jobOrder.description,
                                startTime: jobOrder.startTime,
                                endTime:jobOrder.endTime
                            }
                        });
                        context.jobOrderListLoading = false;
                    }
                }),
                catchError((res) => {
                    context.messageService.add({
                        severity:'error',
                        summary:'Error',
                        detail:res.error?.message ?? res.error.title
                    })
                    return of();
                }),
                finalize(() => {

                })
            )
            .subscribe();
    }
}